import '@hotwired/turbo-rails'
import 'lazysizes'
import './src/flash.ts'
import './src/helpers.ts'
import './src/lightbox.js'
import './src/navigation.js'
import './src/smartquotes.js'
import './src/timezone.js'
import './src/turbo_confirm.js'
import './src/uploader.ts'
import * as Sentry from '@sentry/browser'
import { BrowserTracing } from '@sentry/browser'
import { application } from './controllers/application'
import { Dropdown } from 'tailwindcss-stimulus-components'
import AttachmentsController from  './controllers/attachments_controller.js'
import AttachmentsV2Controller from  './controllers/attachmentsv2_controller.js'
import AutoSubmitController from  './controllers/auto_submit_controller.js'
import AutoFillController from  './controllers/autofill_controller.js'
import ClipboardController from  './controllers/clipboard_controller.js'
import CookieController from  './controllers/cookie_controller.js'
import GrowInputController from  './controllers/grow_input_controller.js'
import InfiniteScrollController from  './controllers/infinite_scroll_controller.js'
import InquireController from  './controllers/inquire_controller.js'
import LightboxController from  './controllers/lightbox_controller.js'
import MultiSubmitController from  './controllers/multi_submit_controller.js'
import NestedFormController from  './controllers/nested_form_controller.js'
import PriceInputController from  './controllers/price_input_controller.js'
import ReadMoreController from  './controllers/read_more_controller.js'
import SlideshowController from  './controllers/slideshow_controller.js'
import SortableController from  './controllers/sortable_controller.js'
import StripeController from  './controllers/stripe_controller.js'
import ToastController from  './controllers/toast_controller.js'
import ToggleController from  './controllers/toggle_controller.js'
import ValidateController from  './controllers/validate_controller.js'

application.register('dropdown', Dropdown)
application.register("attachments", AttachmentsController)
application.register("attachmentsv2", AttachmentsV2Controller)
application.register("auto-submit", AutoSubmitController)
application.register("auto-fill", AutoFillController)
application.register("clipboard", ClipboardController)
application.register("cookie", CookieController)
application.register("grow-input", GrowInputController)
application.register("infinite-scroll", InfiniteScrollController)
application.register("inquire", InquireController)
application.register("lightbox", LightboxController)
application.register("multi-submit", MultiSubmitController)
application.register("nested-form", NestedFormController)
application.register("price-input", PriceInputController)
application.register("read-more", ReadMoreController)
application.register("slideshow", SlideshowController)
application.register("sortable", SortableController)
application.register("stripe", StripeController)
application.register("toast", ToastController)
application.register("toggle", ToggleController)
application.register("validate", ValidateController)

if (process.env.NODE_ENV == 'production') {
  Sentry.init({
    environment: process.env.NODE_ENV,
    dsn: 'https://7c2a37139f2d4be9bc384784b0f824d1@o579424.ingest.sentry.io/5494950',
    tracesSampleRate: 0.5,
    replaysSessionSampleRate: 0.2,
    replaysOnErrorSampleRate: 1.0,
    integrations: [new BrowserTracing(), new Sentry.Replay({})]
  })
}
